import { UNSTABLE_ToastRegion as AriaToastRegion } from 'react-aria-components';
import { QueuedToast, ToastQueue } from 'react-stately';
import { tv } from 'tailwind-variants';
import { ClarionToastComponent } from './Toast';
import { ToastProps } from './toast-types';

export interface ClarionToastRegionProps {
  queue: ToastQueue<ToastProps>;
  className?: string;
}

const toastRegionStyles = tv({
  base: [
    'fixed top-0 right-4 z-50',
    'flex flex-col gap-0',
    'max-w-sm w-full',
    'pointer-events-none',
  ],
});

export function ClarionToastRegion({ queue, className }: ClarionToastRegionProps) {
  const handleClose = (key: string) => queue.close(key);

  return (
    <AriaToastRegion
      queue={queue}
      className={toastRegionStyles({ className })}
      aria-label="Notifications"
    >
      {({ toast }: { toast: QueuedToast<ToastProps> }) => (
        <ClarionToastComponent key={toast.key} toast={toast} onClose={handleClose} />
      )}
    </AriaToastRegion>
  );
}
